import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    CURSOR
} from 'src/styles/fonts/MCFontConstants';
export const Container = styled.div`
    padding: 15px 15px;
`;
export const Header = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: -20px;
    ${media.mobileDevice`
    margin-top:0px;
    `}
`;
export const Icon = styled.img.attrs((props) => ({
    src: props.path,
}))`
    width: 22px;
    height: 23px;
    cursor: ${CURSOR};
`;
export const HeaderTitle = styled.label`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 18px;
    margin-bottom: 12px;
    ${media.mobileDevice`
    margin-bottom:0px;
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 10px;

    &:after {
        content: '*';
        color: red;
        padding-left: 3px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ padding }) => (padding ? padding : '20px 24px')};
    position: relative;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    // align-items:center;
`;
export const UploadImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45%;
    height: 38px;
    border: 1px solid #1010eb;
    border-radius: 25px;
    font-size: 15px;
    font-family: AvenirNextWorld Demi;
    color: #1010eb;
    margin: 15px 0px 0px 0px;
    cursor: pointer;

    ${media.mobileDevice`
        width: 75%;
        padding: 6px 16px;
        font-size: 15px;
        line-height: 27px;
        font-family: AvenirNextWorld Demi;
        color: #1010eb;
    `}
    @media screen and (max-device-width: 375px) {
        width: 100%;
    }
    & label {
        width: 100%;
        text-align: center;
        cursor: pointer;
    }
`;
export const DeleteContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: auto;
    margin-top: 5px;
    height: 40px;
    ${media.mobileDevice`
      width: 100%;
      display: flex;
      justify-content: space-between;
    `}
`;
export const FileName = styled.p`
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #151515;
    /* width: 60%; */
    text-decoration: underline;
    cursor: pointer;
    ${media.mobileDevice`
       text-decoration: none;
    `}
`;
export const ActionButton = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 15px;
    justify-content: flex-end;

    ${media.mobileDevice`
        justify-content: center;
        margin-top: 30px;
    `}
`;
export const DeleteIconView = styled.div`
    display: flex;
    height: 32px;
    width: 32px;
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 6px;
    justify-content: center;
    background-color: #00000029;
    align-items: center;
    cursor: pointer;
    background: #00000029;
    margin: 0 0 0 15px;
    opacity: 0.6;
    ${media.mobileDevice`
    background: #FFF;
    box-shadow: 0px 0px 2px #00000029;
    opacity: 0.7;
`}
`;
export const WarningMsg = styled.div`
    word-break: break-all;
    font-size: 12px;
    color: red;
    font-family: AvenirNextWorld Regular;
    margin: 8px 0px;
`;
export const PdfMainContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 4px #bdbdbd;
    margin: 16px;
    height: ${({ pdfContainerHeight }) => pdfContainerHeight};
    flex-direction: column;
`;
